import React, { useState } from "react";
import { useCompareV2Selector } from "../../../redux/store";
import SectionHeader from "./SectionHeader";
import SpecList from "../list/SpecList";
import { spaceAndRoomCategoryCodes } from "../../../utils/constants";
import * as CompareSectionStyles from "../styles/CompareSection";
import EquipmentLegend from "./EquipmentLegend";
import CollapsibleList from "../list/CollapsibleList";
import useDisplayOptions from "../../../hooks/useDisplayOptions";
import { trackCompareExpandSpecs } from "../../../utils/tracking";

export type carsPecsPropTypes = {
    isPdf?: boolean;
};

const CarSpecs = ({ isPdf }: carsPecsPropTypes): JSX.Element => {
    const cars = useCompareV2Selector((state) => state.newCarCompare.grades);
    const specs = useCompareV2Selector((state) => state.newCarCompare.parsedSpecs);
    const packs = useCompareV2Selector((state) => state.newCarCompare.parsedPacks);
    const equipment = useCompareV2Selector((state) => state.newCarCompare.parsedEquipment);
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);

    const carColours = cars.map((grade) => grade.colourCode);

    const [openAllSpecsCar, setOpenAllSpecsCar] = useState<boolean>(true);
    const { onlyShowDiff, setOnlyShowDiff, showDiffToggle } = useDisplayOptions("Car");

    // both SpecList and CollapsibleList share the same props typing
    const listProps = {
        showPrices: commonSettings.showPrice,
        isPdf,
        showAllSpecs: openAllSpecsCar,
        onlyShowDifferences: onlyShowDiff,
        cultureName: commonSettings.culture.name,
        expandTrackEvent: trackCompareExpandSpecs,
    };

    return (
        <CompareSectionStyles.Wrapper mt={4}>
            <SectionHeader
                title="compareBodyCarSpecsTitle"
                description="compareBodyCarSpecsInfo"
                showAllSpecs={openAllSpecsCar}
                isPdf={isPdf}
                onlyShowDifferences={onlyShowDiff}
                setOnlyShowDifferences={setOnlyShowDiff}
                showToggleDifferences={showDiffToggle}
                toggleShowAllSpecs={setOpenAllSpecsCar}
            />

            <SpecList
                title="compareBodySpaceAndRoomSpecs"
                specs={specs.filter((spec) => spaceAndRoomCategoryCodes.includes(spec.categoryCode.toUpperCase()))}
                isMessageLabel={false}
                {...listProps}
            />

            <EquipmentLegend />

            {equipment.map((spec) => {
                return (
                    <CollapsibleList
                        key={spec.root + spec.category}
                        header={spec.category}
                        items={spec.equipment}
                        isMessageLabel={false}
                        carColours={carColours}
                        {...listProps}
                    />
                );
            })}

            {!!packs.length && (
                <CollapsibleList
                    header="compareSectionPacks"
                    isMessageLabel
                    items={packs}
                    carColours={carColours}
                    {...listProps}
                />
            )}
        </CompareSectionStyles.Wrapper>
    );
};

export default CarSpecs;
